// src/data/delhiPincodes.js
// Complete Delhi pincode data with coordinates

export const DELHI_PINCODES = {
  '110001': { lat: 28.6315, lng: 77.2167, area: 'Connaught Place' },
  '110002': { lat: 28.6361, lng: 77.2444, area: 'Daryaganj' },
  '110003': { lat: 28.6017, lng: 77.2350, area: 'Golf Links' },
  '110004': { lat: 28.6142, lng: 77.2006, area: 'Rashtrapati Bhawan' },
  '110005': { lat: 28.6567, lng: 77.1886, area: 'Karol Bagh' },
  '110006': { lat: 28.6615, lng: 77.2286, area: 'Chandni Chowk' },
  '110007': { lat: 28.6712, lng: 77.2071, area: 'Kamla Nagar' },
  '110008': { lat: 28.6447, lng: 77.1655, area: 'Patel Nagar' },
  '110009': { lat: 28.6848, lng: 77.2154, area: 'Mukherjee Nagar' },
  '110010': { lat: 28.5969, lng: 77.1333, area: 'Delhi Cantt' },
  '110011': { lat: 28.6103, lng: 77.2111, area: 'South Avenue' },
  '110012': { lat: 28.6228, lng: 77.1569, area: 'Inderpuri' },
  '110013': { lat: 28.5939, lng: 77.2522, area: 'Nizamuddin' },
  '110014': { lat: 28.5897, lng: 77.2486, area: 'Jangpura' },
  '110015': { lat: 28.6569, lng: 77.1436, area: 'Kirti Nagar' },
  '110016': { lat: 28.5539, lng: 77.1952, area: 'Hauz Khas' },
  '110017': { lat: 28.5248, lng: 77.2068, area: 'Saket' },
  '110018': { lat: 28.6412, lng: 77.0774, area: 'Vikaspuri' },
  '110019': { lat: 28.5512, lng: 77.2511, area: 'Nehru Place' },
  '110020': { lat: 28.5611, lng: 77.3033, area: 'Okhla' },
  '110021': { lat: 28.5866, lng: 77.1675, area: 'Satya Niketan' },
  '110022': { lat: 28.5117, lng: 77.2967, area: 'Tughlakabad' },
  '110023': { lat: 28.5683, lng: 77.1706, area: 'RK Puram' },
  '110024': { lat: 28.5811, lng: 77.2406, area: 'Defence Colony' },
  '110025': { lat: 28.5736, lng: 77.2739, area: 'Jamia Nagar' },
  '110026': { lat: 28.6626, lng: 77.1339, area: 'Punjabi Bagh' },
  '110027': { lat: 28.6394, lng: 77.1200, area: 'Rajouri Garden' },
  '110028': { lat: 28.5853, lng: 77.1631, area: 'Shanti Niketan' },
  '110029': { lat: 28.5589, lng: 77.1942, area: 'Yusuf Sarai' },
  '110030': { lat: 28.5700, lng: 77.2819, area: 'New Friends Colony' },
  '110031': { lat: 28.6617, lng: 77.2744, area: 'Gandhi Nagar' },
  '110032': { lat: 28.6847, lng: 77.2867, area: 'Shahdara' },
  '110033': { lat: 28.7147, lng: 77.1975, area: 'GTB Nagar' },
  '110034': { lat: 28.6881, lng: 77.1314, area: 'Pitampura' },
  '110035': { lat: 28.6783, lng: 77.1583, area: 'Inderlok' },
  '110036': { lat: 28.7958, lng: 77.1719, area: 'Alipur' },
  '110037': { lat: 28.5481, lng: 77.1194, area: 'Mahipalpur' },
  '110038': { lat: 28.5292, lng: 77.1356, area: 'Rajokari' },
  '110039': { lat: 28.8047, lng: 77.0444, area: 'Bawana' },
  '110040': { lat: 28.8353, lng: 77.1447, area: 'Narela' },
  '110041': { lat: 28.7228, lng: 77.0811, area: 'Kirari' },
  '110042': { lat: 28.7278, lng: 77.1633, area: 'Badli' },
  '110043': { lat: 28.5517, lng: 77.3033, area: 'Madanpur Khadar' },
  '110044': { lat: 28.5072, lng: 77.3033, area: 'Badarpur' },
  '110045': { lat: 28.6708, lng: 77.0708, area: 'Nangloi' },
  '110046': { lat: 28.6081, lng: 77.0797, area: 'Bindapur' },
  '110047': { lat: 28.4967, lng: 77.1331, area: 'Arjun Garh' },
  '110048': { lat: 28.5535, lng: 77.2401, area: 'Greater Kailash' },
  '110049': { lat: 28.5661, lng: 77.2389, area: 'Andrews Ganj' },
  '110050': { lat: 28.6722, lng: 77.2889, area: 'Welcome Colony' },
  '110051': { lat: 28.6514, lng: 77.2714, area: 'Krishna Nagar' },
  '110052': { lat: 28.6691, lng: 77.1921, area: 'Shastri Nagar' },
  '110053': { lat: 28.6833, lng: 77.2917, area: 'Jafrabad' },
  '110054': { lat: 28.6764, lng: 77.2242, area: 'Civil Lines' },
  '110055': { lat: 28.6439, lng: 77.2142, area: 'Paharganj' },
  '110056': { lat: 28.4275, lng: 77.1722, area: 'Bhati Mines' },
  '110057': { lat: 28.4975, lng: 77.1722, area: 'Chhatarpur' },
  '110058': { lat: 28.6200, lng: 77.0857, area: 'Janakpuri' },
  '110059': { lat: 28.6486, lng: 77.1264, area: 'Rajouri Garden Ext' },
  '110060': { lat: 28.6428, lng: 77.1778, area: 'Rajendra Nagar' },
  '110061': { lat: 28.6128, lng: 77.0681, area: 'Dabri' },
  '110062': { lat: 28.5444, lng: 77.2861, area: 'Okhla Phase 2' },
  '110063': { lat: 28.7078, lng: 77.1233, area: 'Prashant Vihar' },
  '110064': { lat: 28.6306, lng: 77.1014, area: 'Hari Nagar' },
  '110065': { lat: 28.5661, lng: 77.2569, area: 'East of Kailash' },
  '110066': { lat: 28.5458, lng: 77.2417, area: 'Sheikh Sarai' },
  '110067': { lat: 28.5589, lng: 77.1697, area: 'JNU' },
  '110068': { lat: 28.4783, lng: 77.1972, area: 'Lado Sarai' },
  '110069': { lat: 28.5275, lng: 77.1439, area: 'Kishangarh' },
  '110070': { lat: 28.5248, lng: 77.1476, area: 'Vasant Kunj' },
  '110071': { lat: 28.6072, lng: 77.0400, area: 'Chhawla' },
  '110072': { lat: 28.4931, lng: 77.1556, area: 'Sultanpur' },
  '110073': { lat: 28.4556, lng: 77.1917, area: 'Asola' },
  '110074': { lat: 28.4969, lng: 77.2094, area: 'Maidan Garhi' },
  '110075': { lat: 28.5792, lng: 77.0658, area: 'Dwarka' },
  '110076': { lat: 28.5356, lng: 77.3033, area: 'Sarita Vihar' },
  '110077': { lat: 28.5842, lng: 77.0389, area: 'Dwarka Sector 16' },
  '110078': { lat: 28.5986, lng: 77.0464, area: 'Dwarka Sector 12' },
  '110079': { lat: 28.6103, lng: 77.0222, area: 'Deenpur' },
  '110080': { lat: 28.4694, lng: 77.1611, area: 'Jhatikara' },
  '110081': { lat: 28.7283, lng: 77.0458, area: 'Kanjhawala' },
  '110082': { lat: 28.7383, lng: 77.1819, area: 'Khera Kalan' },
  '110083': { lat: 28.7514, lng: 77.1103, area: 'Qutubgarh' },
  '110084': { lat: 28.7244, lng: 77.1931, area: 'Burari' },
  '110085': { lat: 28.7344, lng: 77.1245, area: 'Rohini' },
  '110086': { lat: 28.7489, lng: 77.0911, area: 'Rohini Sector 16' },
  '110087': { lat: 28.6767, lng: 77.0572, area: 'Nangloi' },
  '110088': { lat: 28.7139, lng: 77.1172, area: 'Prashant Vihar' },
  '110089': { lat: 28.7589, lng: 77.0983, area: 'Rohini Sector 21' },
  '110090': { lat: 28.7028, lng: 77.0667, area: 'Karala' },
  '110091': { lat: 28.6078, lng: 77.2994, area: 'Mayur Vihar Phase 1' },
  '110092': { lat: 28.6304, lng: 77.2743, area: 'Laxmi Nagar' },
  '110093': { lat: 28.6639, lng: 77.3103, area: 'Mandoli' },
  '110094': { lat: 28.7000, lng: 77.2811, area: 'Karawal Nagar' },
  '110095': { lat: 28.6800, lng: 77.3033, area: 'Dilshad Garden' },
  '110096': { lat: 28.6239, lng: 77.3250, area: 'Ghazipur' }
};

// Haversine distance formula
function calculateDistance(lat1, lon1, lat2, lon2) {
  const R = 6371; // Earth's radius in km
  const dLat = (lat2 - lat1) * Math.PI / 180;
  const dLon = (lon2 - lon1) * Math.PI / 180;
  const a = Math.sin(dLat/2) * Math.sin(dLat/2) +
            Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
            Math.sin(dLon/2) * Math.sin(dLon/2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  return R * c;
}

// Get nearby pincodes within radius km (pure browser, no API calls)
export const getNearbyPincodes = (targetPincode, radiusKm = 3) => {
  const target = DELHI_PINCODES[targetPincode];
  if (!target) return [targetPincode];
  
  const nearby = [];
  
  for (const [pincode, data] of Object.entries(DELHI_PINCODES)) {
    const distance = calculateDistance(target.lat, target.lng, data.lat, data.lng);
    if (distance <= radiusKm) {
      nearby.push(pincode);
    }
  }
  
  return nearby;
};

// Get all pincodes
export const getAllPincodes = () => Object.keys(DELHI_PINCODES);

// Get pincode info
export const getPincodeInfo = (pincode) => DELHI_PINCODES[pincode];

// Add this function at the bottom of the file
export const debugNearbyPincodes = (targetPincode, radiusKm = 3) => {
  const target = DELHI_PINCODES[targetPincode];
  if (!target) {
    console.log(`❌ Pincode ${targetPincode} not found in database`);
    return [];
  }
  
  console.log(`\n🔍 SEARCHING for nearby pincodes to ${targetPincode} (${target.area})`);
  console.log(`📍 Target coordinates: ${target.lat}, ${target.lng}`);
  console.log(`📏 Radius: ${radiusKm}km`);
  console.log(`📊 Total pincodes in database: ${Object.keys(DELHI_PINCODES).length}\n`);
  
  const results = [];
  let checked = 0;
  
  for (const [pincode, data] of Object.entries(DELHI_PINCODES)) {
    checked++;
    const distance = calculateDistance(target.lat, target.lng, data.lat, data.lng);
    
    if (distance <= radiusKm) {
      results.push({ pincode, distance: distance.toFixed(2), area: data.area });
      console.log(`  ✅ ${pincode} (${data.area}) - ${distance.toFixed(2)}km - INCLUDED`);
    }
  }
  
  console.log(`\n📊 SUMMARY:`);
  console.log(`   Total pincodes checked: ${checked}`);
  console.log(`   Pincodes within ${radiusKm}km: ${results.length}`);
  console.log(`   Matched pincodes: ${results.map(r => r.pincode).join(', ')}`);
  
  return results;
};